<template>
    <div class="btn-stock">
        <button class="btn btn-sm btn-outline-secondary" @click="stock">Re-lancer le stock</button>
    </div>
</template>

<script>
export default {
    name: "BtnStock",
    props: {
        manufacturerId: {
            required: true
        }
    },
    methods: {
        stock() {
            axios
                .post('/manufacturers/syncCatalog/' + this.manufacturerId, {
                    mode: 'sync_stock',
                    options: {}
                })
                .then(r => {
                    this.$message({
                        type: 'success',
                        message: r.data.message
                    });
                })
                .catch(e => {
                    if (e.response.status == 422) {
                        this.$message.error(e.response.data.errors);
                    } else {
                        this.$message.error(e.response.data.message);
                    }
                })
                .then(() => {});
        }
    }
}
</script>

<style scoped>

</style>
